import { TextInput } from '@mantine/core';
import React, {useEffect, useState} from 'react';

interface Props {

}

const Time = (props: Props) => {

  const [time, setTime] = useState("")

  const f2 = (num: number) => num < 10 ? `0${num}` : num

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date()

      setTime(`${now.getFullYear()}${f2(now.getMonth()+1)}${f2(now.getDate())}${f2(now.getHours())}${f2(now.getMinutes())}`)
    }, 500)

    return () => clearInterval(interval)
  }, [])

  return (
    <>
      <TextInput label="time" readOnly value={time}/>
    </>
  )
}

export default Time